export type Lang = 'en' | 'ua' | 'ru' | 'ro'

export const LANGS: Lang[] = ['en', 'ua', 'ru', 'ro']

/**
 * Pages that use a different, language-specific slug per locale.
 * Paths are stored WITHOUT the leading /<lang> prefix so they can be
 * combined with any locale for canonical + hreflang generation.
 */
export const orthodonticAppliancesPaths: Record<Lang, string> = {
  en: '/services/orthodontic-appliances',
  ua: '/services/ortodontychni-aparaty',
  ru: '/services/ortodonticheskie-apparaty',
  ro: '/services/aparate-ortodontice',
}

const localizedRouteGroups: Record<Lang, string>[] = [
  orthodonticAppliancesPaths,
]

export function isLang(value: string | undefined): value is Lang {
  return !!value && (LANGS as string[]).includes(value)
}

/** Full in-app href for the Orthodontic Appliances page in a given language. */
export function orthodonticAppliancesHref(lang: string): string {
  const safeLang: Lang = isLang(lang) ? lang : 'en'
  return `/${safeLang}${orthodonticAppliancesPaths[safeLang]}`
}

/** Strips the /<lang> prefix from a pathname. */
export function stripLocale(pathname: string): string {
  const path = pathname.replace(/^\/(en|ua|ru|ro)(?=\/|$)/, '') || '/'
  return path === '/' ? '' : path.replace(/\/$/, '')
}

/**
 * Translates the current pathname into another language, swapping the locale
 * prefix and any language-specific slug (e.g. Orthodontic Appliances).
 */
export function translatePath(pathname: string, newLang: Lang): string {
  const pathWithoutLocale = stripLocale(pathname)
  for (const group of localizedRouteGroups) {
    const matched = LANGS.some(
      (locale) => group[locale] === pathWithoutLocale,
    )
    if (matched) {
      return `/${newLang}${group[newLang]}`
    }
  }
  return `/${newLang}${pathWithoutLocale}`
}
